import { gql } from '@apollo/client';
import { AUTHENTICATION_ERROR_FRAGMENTS } from '@graphql/fragments/errorsFragment';

export const REFRESH_TOKEN_MUTATION = gql`
  mutation RefreshToken($input: RefreshTokenInput!) {
    refreshToken(input: $input) {
      accessToken
      refreshToken
      errors {
        ...AuthenticationErrorFields
      }
    }
  }
  ${AUTHENTICATION_ERROR_FRAGMENTS}
`;
